import React, { useState } from 'react';

function PaymentLink() {
  const [schoolName, setSchoolName] = useState('');
  const [amount, setAmount] = useState('');
  const [paymentLink, setPaymentLink] = useState('');

  const generatePaymentLink = () => {
    if (!schoolName || !amount) {
      alert('Please enter school name and amount');
      return;
    }

    // BZ Pay style payment link
    const link = `https://www.bz-payment.com/pay?school=${encodeURIComponent(
      schoolName
    )}&amount=${amount}`;

    setPaymentLink(link);
  };

  const copyLink = () => {
    navigator.clipboard.writeText(paymentLink);
    alert('BZ Pay payment link copied');
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>BZ Pay Payment Link</h1>

      <input
        type="text"
        placeholder="Enter school name"
        value={schoolName}
        onChange={(e) => setSchoolName(e.target.value)}
      />

      <br /><br />

      <input
        type="number"
        placeholder="Enter amount"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
      />

      <br /><br />

      <button onClick={generatePaymentLink}>
        Generate BZ Pay Link
      </button>

      {paymentLink && (
        <div style={{ marginTop: '20px' }}>
          <p>{paymentLink}</p>
          <button onClick={copyLink}>Copy Link</button>
        </div>
      )}
    </div>
  );
}

export default PaymentLink;